const BillingItemsStore = {
	data: {
		billingItems: [
			{
				code: '00010',
				name: 'Injection - Intramuscular',
				shortName: 'Intramuscular',
				amount: 10.38,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00011',
				name: 'Injection - Intravenus',
				shortName: 'Intravenus',
				amount: 12.25,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00012',
				name: 'Venepuncture',
				shortName: 'Venepuncture',
				amount: 5.71,
				suggestions: ['01135', '01138'],
				conflictsDiagnosis: ['13308'],
				filterStatus: true,
			},
			{
				code: '00013',
				name: 'Injection - Intra-arterial',
				shortName: 'Intra-arterial',
				amount: 15.37,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00014',
				name: 'Injection - Intra-arterial, Hip',
				shortName: 'Intra-arterial, Hip',
				amount: 24.50,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00015',
				name: 'Injection - Intra-arterial, All other joints',
				shortName: 'Intra-arterial, All other',
				amount: 16.29,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00016',
				name: 'Injection - Intrathecal',
				shortName: 'Injection - Intrathecal',
				amount: 32.67,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00017',
				name: 'Insertion of central venous pressure catheter',
				shortName: 'Central venous pressure catheter',
				amount: 23.32,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00018',
				name: 'Blood transfusion - autologous ascitic infusion',
				shortName: 'Autologous ascitic infusion',
				amount: 46.93,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00019',
				name: 'Venesection for polycythaemia or phlebotomy',
				shortName: 'Venesection',
				amount: 30.24,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00020',
				name: 'Blood transfusion - Administered outside hospital',
				shortName: 'Outside hospital',
				amount: 60.13,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00021',
				name: 'Blood transfusion - In hospital',
				shortName: 'In hospital',
				amount: 36.38,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00022',
				name: 'Serum transfusion',
				shortName: 'Serum transfusion',
				amount: 23.93,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00023',
				name: 'Blood transfusion with vein dissection',
				shortName: 'With vein dissection',
				amount: 50.97,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00024',
				name: 'Vein dissection for I.V. therapy',
				shortName: 'Vein dissection',
				amount: 35.59,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00025',
				name: 'Hyperbaric chamber - Phy in chamber - First 30 mins',
				shortName: 'In chamber - 1st 30 mins',
				amount: 78.83,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00026',
				name: 'Hyperbaric chamber - Phy in chamber - Additional 15 mins',
				shortName: 'In chamber - +15 mins',
				amount: 40.48,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00027',
				name: 'Hyperbaric chamber - Phy outside chamber - First 30 mins',
				shortName: 'Outside chamber - 1st 30 mins',
				amount: 53.69,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00028',
				name: 'Hyperbaric chamber - Phy outside chamber - Additional 15 mins',
				shortName: 'Outside chamber - +15 mins',
				amount: 28.50,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '00100',
				name: 'Visit in office (age 2 - 49)',
				shortName: 'Visit (age 2 - 49)',
				amount: 30.32,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '01005',
				name: 'Anaesthesia for MRI or CT scan - per 15 mins',
				shortName: 'Anaesthesia /15 mins',
				amount: 35.94,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '01007',
				name: 'Catheter insertion intrapleural for main management',
				shortName: 'Catheter intrapleural',
				amount: 80.63,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '02100',
				name: 'Muellerectomy - Graded',
				shortName: 'Muellerectomy - Graded',
				amount: 461.42,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '03100',
				name: 'Inter-operative ultrasound during neurosurgery',
				shortName: 'Ultrasound',
				amount: 40.09,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04008',
				name: 'Visit - Hospital - OB&G',
				shortName: 'Visit - Hospital',
				amount: 48.12,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04010',
				name: 'Consultation - OB&G',
				shortName: 'Consultation - Hospital',
				amount: 140.41,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04017',
				name: 'Midcavity rotation - Surgical delivery',
				shortName: 'Midcavity rotation',
				amount: 504.17,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04018',
				name: 'Breech vaginal birth',
				shortName: 'Breech vaginal birth',
				amount: 504.17,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04026',
				name: 'Retained placenta - Manual removal',
				shortName: 'Retained placenta',
				amount: 214.59,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04039',
				name: 'Management of complicated labour by obstetrician',
				shortName: 'Complicated labour',
				amount: 608.19,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04092',
				name: 'Multiple natural births - Each additional child',
				shortName: 'Visit - Hospital',
				amount: 160.98,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04107',
				name: 'Supervision of labour and vaginal delivery',
				shortName: 'Vaginal delivery',
				amount: 120.83,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04118',
				name: 'Induction or stimulation of labour by oxytocin - First hour',
				shortName: 'Oxytonix - 1st hour',
				amount: 37.77,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '04119',
				name: 'Induction or stimulation of labour by oxytocin - Subsequent hours',
				shortName: 'Oxytocin - Subs. hours',
				amount: 25.87,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '14199',
				name: 'Management of prolonged second stage labour - Per 30 mins',
				shortName: '2nd stage labour / 30 mins',
				amount: 81.41,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '08100',
				name: 'Perinephric abscess - Drainage',
				shortName: 'Perinephric abscess - Drainage',
				amount: 475.00,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '10001',
				name: 'Urgent specialist advice (phone or in person)',
				shortName: 'Urgent advice',
				amount: 60.00,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '10002',
				name: 'Specialist advice for patient management - One week',
				shortName: 'Advice - One week',
				amount: 40.00,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '10003',
				name: 'Specialist patient management / follow up',
				shortName: 'Management / follow up',
				amount: 24.05,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '10004',
				name: 'Specialist multidisciplinary conferencing for complex patient',
				shortName: 'Conferencing',
				amount: 50.00,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '10005',
				name: 'Specialist email advice for patient management',
				shortName: 'Email advice',
				amount: 10.10,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '10006',
				name: 'Specialist email patient management - Follow up',
				shortName: 'Email - Follow up',
				amount: 10.10,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '13308',
				name: 'Community based GP - Hospital visit',
				shortName: 'Hospital visit',
				amount: 32.81,
				suggestions: ['13339'],
				conflictsDiagnosis: ['00012'],
				filterStatus: true,
			},
			{
				code: '13334',
				name: 'Long term care facility visit - First of the day bonus - Extra',
				shortName: 'First LTC visit bonus',
				amount: 32.81,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '13338',
				name: 'Community based GP -  First facility visit of the day bonus - Extra',
				shortName: 'First facilty visit bonus',
				amount: 36.18,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '13339',
				name: 'Community based GP -  First hospital visit of the day bonus - Extra',
				shortName: 'First hospital visit bonus',
				amount: 28.76,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '01135',
				name: 'Epidural block - Lumbar',
				shortName: 'Lumbar',
				amount: 145.12,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '01138',
				name: 'Epidural block - Caudal',
				shortName: 'Caudal',
				amount: 145.12,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33705',
				name: 'Emergency Visit - Nephrology',
				shortName: 'Emergency Visit',
				amount: 107.45,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33706',
				name: 'Directive care - Nephrology',
				shortName: 'Directive care',
				amount: 43.60,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33707',
				name: 'Office visit - Nephrology',
				shortName: 'Office visit',
				amount: 45.54,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33708',
				name: 'Hospital visit - Nephrology',
				shortName: 'Hospital visit',
				amount: 47.96,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33709',
				name: 'VISIT-HOME-NEPHROLOGY',
				shortName: 'Home visit',
				amount: 48.49,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33710',
				name: 'Consultation - Nephrology',
				shortName: 'Consultation',
				amount: 160.47,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33712',
				name: 'Repeat or limited consultation - Nephrology',
				shortName: 'Repeat or ltd consult',
				amount: 77.04,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33713',
				name: 'Group counselling (first hour)',
				shortName: 'Counselling - 1st hr',
				amount: 105.99,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33714',
				name: 'Prolonged Visit for Counselling (Max 4 per year)',
				shortName: 'Prolonged Visit',
				amount: 51.76,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33715',
				name: 'Group counselling (each additional 1/2 hour)',
				shortName: 'Group counselling - extra 0.5hr',
				amount: 52.96,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33723',
				name: 'Initial Peritoneal Dialysis (First 2 Weeks)',
				shortName: 'Peritoneal - 1st 2 weeks',
				amount: 394.51,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33730',
				name: 'TELEHEALTH-CONSULT-NEPHROLOGY',
				shortName: 'TELEHEALTH-CONSULT-NEPHROLOGY',
				amount: 169.49,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33732',
				name: 'TELEHEALTH-REPEAT CONSULT-NEPHROLOGY',
				shortName: 'TELEHEALTH-REPEAT CONSULT-NEPHROLOGY',
				amount: 81.37,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33736',
				name: 'TELEHEALTH-DIRECTIVE CARE-NEPHROLOGY',
				shortName: 'TELEHEALTH-DIRECTIVE CARE-NEPHROLOGY',
				amount: 59.72,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33737',
				name: 'TELEHEALTH-SUBSEQUENT OFFICE VISIT-NEPHROLOGY',
				shortName: '	TELEHEALTH-SUBSEQUENT OFFICE VISIT-NEPHROLOGY',
				amount: 47.11,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33738',
				name: 'TELEHEALTH-SUBSEQUENT HOSPITAL VISIT-NEPHROLOGY',
				shortName: 'TELEHEALTH-SUBSEQUENT HOSPITAL VISIT-NEPHROLOGY',
				amount: 47.96,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33750',
				name: 'Hemodialysis (Round 1)',
				shortName: 'Hemodialysis (Round 1)',
				amount: 527.32,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33751',
				name: 'Hemodialysis ( Round 2 to 5)',
				shortName: 'Hemodialysis (Rounds 2-5)',
				amount: 198.16,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33752',
				name: 'Temporary HD Line Insertion',
				shortName: 'Temporary HD Line Insertion',
				amount: 133.31,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33756',
				name: 'PD Tube Reinsertion (10 days after initial)',
				shortName: 'PD Tube Reinsertion (10 days after initial)',
				amount: 51.83,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33758',
				name: 'Chronic Hemodialysis (Rounds 6+)',
				shortName: 'Hemodialysis (Rounds 6+)',
				amount: 51.83,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33759',
				name: 'Chronic Peritoneal Dialysis',
				shortName: 'Chronic Peritoneal Dialysis',
				amount: 51.83,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33761',
				name: 'Home dialysis',
				shortName: 'Home dialysis',
				amount: 61.91,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '33790',
				name: 'RENAL TRANSPLANT PATIENT-CARE OF',
				shortName: 'RENAL TRANSPLANT PATIENT-CARE OF',
				amount: 1173.34,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '77380',
				name: '	Peritoneal Catheter Insertion',
				shortName: '	Peritoneal Catheter Insertion',
				amount: 189.26,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
			{
				code: '77385',
				name: 'Peritoneal Catheter Removal',
				shortName: 'Peritoneal Catheter Removal',
				amount: 131.28,
				suggestions: [],
				conflictsDiagnosis: [],
				filterStatus: true,
			},
		]
	},
	methods: {
		getBillingItemObject($code) {
			let $index = BillingItemsStore.data.billingItems.findIndex(
				element => element.code == $code
			);

			return BillingItemsStore.data.billingItems[$index];
		},
		setStatus($code, $status) {
			let $index = BillingItemsStore.data.billingItems.findIndex(
				element => element.code == $code
			);

			BillingItemsStore.data.billingItems[$index].filterStatus = $status;
		}
	}
};

export default BillingItemsStore;